<template>
    <v-card style="border-radius: 1em;">
        <v-toolbar color="error" style="justify-content: center; display: flex;">
            <v-toolbar-title class="white--text">
                {{bloqueio.existe ? 'Desbloquear' :'Bloquear'}} Empresa
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <p class="mt-3" style="font-size: 1.2em;">
            {{ bloqueio.existe ? `Retira as restrições inseridas a empresa ${empresa.nome_fantasia}, possibilitando o envio de proposta e o abastecimento em seu posto.` : `Inseri restrições a empresa ${empresa.nome_fantasia}, impossibilitando o envio de propostas e a realização de abastecimento em seu posto.` }}
            </p>
        </v-card-text>
        <v-card-text>
            <v-textarea
                v-if="!bloqueio.existe"
                outline
                label="Digite o Motivo"
                v-model="texto"
                maxlength="255"
                required
                counter
                full-width
                single-line
            />
            <v-btn
                :disabled="!bloqueio.existe && (texto === '' || !texto || texto === null)"
                block
                round
                color="error"
                @click="bloquear"
            >
                {{ bloqueio.existe? 'Desbloquear' : 'Bloquear' }}
            </v-btn>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
  props: ['fatura'],
  data () {
    return {
      texto: '',
      bloqueio: { id: null, existe: false },
      empresa: null
    }
  },
  methods: {
    bloquear () {
      if (!this.bloqueio.existe) {
        const idRede = this.fatura.rede ? this.fatura.rede.id_rede : null
        this.$store.dispatch('BloqueioEmpresa', { empresa: this.empresa.cnpj, motivo: this.texto, rede: idRede }).then(() => {
          this.pegarBloqueio()
          this.texto = ''
        })
      } else {
        this.$store.dispatch('BloqueioEmpresa', { id: this.bloqueio.id }).then(() => {
          this.pegarBloqueio()
        })
      }
    },
    pegarBloqueio () {
      const idRede = this.fatura.rede ? this.fatura.rede.id_rede : null
      this.$store.dispatch('temBloqueio', { empresa: this.empresa.cnpj, rede: idRede }).then(json => {
        this.bloqueio = json
      })
    }
  },
  beforeMount () {
    if (this.fatura) {
      this.empresa = this.fatura.empresa_fatura
      this.pegarBloqueio()
    }
  }
}
</script>
